import { AfterContentInit, ChangeDetectionStrategy, Component, ContentChildren, QueryList } from '@angular/core';
import { TabComponent } from '../tab/tab.component';

@Component({
  selector: 'ui-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabsComponent implements AfterContentInit {
  @ContentChildren(TabComponent) public tabs!: QueryList<TabComponent>;

  public ngAfterContentInit(): void {
    if (this.tabs.length && !this.findActive()) {
      this.tabs.first.active = true;
    }
  }

  public selectTab(event: Event, tab: TabComponent): void {
    event.preventDefault();

    const current: TabComponent | undefined = this.findActive();

    /* istanbul ignore else */
    if (current) {
      current.active = false;
    }

    tab.active = true;
  }

  private findActive(): TabComponent | undefined {
    return this.tabs.find((tab: TabComponent) => Boolean(tab.active));
  }
}
